// extracted by mini-css-extract-plugin
export var content = "_mt-1";
export var fullScreen = "_mt-0";